import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSave = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 19,
	viewBox: "0 0 18 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2 18.7276H16C16.5304 18.7276 17.0391 18.5168 17.4142 18.1418C17.7893 17.7667 18 17.258 18 16.7276V5.72756C18.0008 5.59595 17.9755 5.46549 17.9258 5.34365C17.876 5.22181 17.8027 5.111 17.71 5.01756L13.71 1.01756C13.6166 0.924874 13.5057 0.851549 13.3839 0.801785C13.2621 0.75202 13.1316 0.726795 13 0.727556H2C1.46957 0.727556 0.960859 0.938269 0.585786 1.31334C0.210714 1.68841 0 2.19712 0 2.72756V16.7276C0 17.258 0.210714 17.7667 0.585786 18.1418C0.960859 18.5168 1.46957 18.7276 2 18.7276ZM12 16.7276H6V11.7276H12V16.7276ZM10 4.72756H8V2.72756H10V4.72756ZM2 2.72756H4V6.72756H12V2.72756H12.59L16 6.13756V16.7276H14V11.7276C14 11.1971 13.7893 10.6884 13.4142 10.3133C13.0391 9.93827 12.5304 9.72756 12 9.72756H6C5.46957 9.72756 4.96086 9.93827 4.58579 10.3133C4.21071 10.6884 4 11.1971 4 11.7276V16.7276H2V2.72756Z",
		fill: "currentColor"
	})
});
export default SvgSave;
